/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Mvp_Sprint_TitleInputs */

const en_svc_mvp_sprint_title = /** @type {(inputs: Svc_Mvp_Sprint_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fixed-Price MVP Sprint`)
};

const ar_svc_mvp_sprint_title = /** @type {(inputs: Svc_Mvp_Sprint_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سباق MVP بسعر ثابت`)
};

const bn_svc_mvp_sprint_title = /** @type {(inputs: Svc_Mvp_Sprint_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ফিক্সড-প্রাইস MVP স্প্রিন্ট`)
};

const de_svc_mvp_sprint_title = /** @type {(inputs: Svc_Mvp_Sprint_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MVP-Sprint zum Festpreis`)
};

const es_svc_mvp_sprint_title = /** @type {(inputs: Svc_Mvp_Sprint_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprint MVP a precio fijo`)
};

const fr_svc_mvp_sprint_title = /** @type {(inputs: Svc_Mvp_Sprint_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprint MVP au forfait`)
};

const pt_svc_mvp_sprint_title = /** @type {(inputs: Svc_Mvp_Sprint_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprint MVP a preço fixo`)
};

const zh_svc_mvp_sprint_title = /** @type {(inputs: Svc_Mvp_Sprint_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`固定价格 MVP 冲刺`)
};

const tr_svc_mvp_sprint_title = /** @type {(inputs: Svc_Mvp_Sprint_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sabit Fiyatlı MVP Sprinti`)
};

const ru_svc_mvp_sprint_title = /** @type {(inputs: Svc_Mvp_Sprint_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MVP-спринт за фикс-прайс`)
};

const pl_svc_mvp_sprint_title = /** @type {(inputs: Svc_Mvp_Sprint_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprint MVP za stałą cenę`)
};

/**
* | output |
* | --- |
* | "Fixed-Price MVP Sprint" |
*
* @param {Svc_Mvp_Sprint_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_mvp_sprint_title = /** @type {((inputs?: Svc_Mvp_Sprint_TitleInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Mvp_Sprint_TitleInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_mvp_sprint_title(inputs)
	if (locale === "bn") return bn_svc_mvp_sprint_title(inputs)
	if (locale === "de") return de_svc_mvp_sprint_title(inputs)
	if (locale === "es") return es_svc_mvp_sprint_title(inputs)
	if (locale === "fr") return fr_svc_mvp_sprint_title(inputs)
	if (locale === "pt") return pt_svc_mvp_sprint_title(inputs)
	if (locale === "zh") return zh_svc_mvp_sprint_title(inputs)
	if (locale === "tr") return tr_svc_mvp_sprint_title(inputs)
	if (locale === "ru") return ru_svc_mvp_sprint_title(inputs)
	if (locale === "pl") return pl_svc_mvp_sprint_title(inputs)
	return en_svc_mvp_sprint_title(inputs)
});
export { svc_mvp_sprint_title as "svc_mvp-sprint_title" }